import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { retrieveToken } from "../../../../utils/storage";

const baseUrl = process.env.REACT_APP_API_URL;

const uploadImageOnServer = async (file) => {
  const url = await fetch(baseUrl + "admin/News/getuploadurl", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${retrieveToken()}`,
    },
    cache: "no-store",
  });
  const destrUrl = await url.json();
  let clearURL = "";
  if (destrUrl?.Data) {
    const uploadFileUrl = destrUrl.Data;
    await fetch(uploadFileUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: new Blob([file]),
    });

    clearURL = uploadFileUrl.split("?")[0];
  }
  return clearURL;
};

function ImageUploader(quill) {
  const toolbar = quill.getModule("toolbar");
  toolbar.addHandler("image", () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;
      const imgURL = await uploadImageOnServer(file);
      const range = quill.getSelection(true);
      quill.insertEmbed(range.index, "image", imgURL);
      quill.setSelection(range.index + 1);
    };
  });
}

const NewsTextEditor = ({ text, handleChangeText }) => {
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ align: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["blockquote", "code-block"],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      ["link", "image"],
      ["clean"],
    ],
    ImageUploader: true,
  };

  return (
    <div className="w-full px-8">
      <ReactQuill
        value={text}
        onChange={handleChangeText}
        modules={modules}
        style={{ height: "60vh" }}
      />
    </div>
  );
};

ReactQuill.Quill.register("modules/ImageUploader", ImageUploader);

export default NewsTextEditor;
